<template>
  <div>
    <ui-save-bar id="my-save-bar">
      <button
        variant="primary"
        id="save-button"
        @click="onSaveBarSaveClicked"
      ></button>
      <button id="discard-button" @click="onSaveBarDiscardClicked"></button>
    </ui-save-bar>

    <div
      class="Polaris-InlineGrid"
      style="--pc-inline-grid-grid-template-columns-xs: 1fr; --pc-inline-grid-grid-template-columns-md: 2fr 5fr; --pc-inline-grid-gap-xs: var(--p-space-400); margin-top: var(--p-space-500);"
    >
      <section
        class="Polaris-Box"
        style="--pc-box-padding-inline-start-xs: var(--p-space-400); --pc-box-padding-inline-start-sm: var(--p-space-0); --pc-box-padding-inline-end-xs: var(--p-space-400); --pc-box-padding-inline-end-sm: var(--p-space-0);"
      >
        <div
          class="Polaris-BlockStack"
          style="--pc-block-stack-order: column; --pc-block-stack-gap-xs: var(--p-space-400);"
        >
          <h3 class="Polaris-Text--root Polaris-Text--headingMd">
            Email notifications
          </h3>
          <p class="Polaris-Text--root Polaris-Text--bodyMd">
            Subscribe for abandoned carts alerts through emails
          </p>
        </div>
      </section>

      <div
        class="Polaris-ShadowBevel"
        style="--pc-shadow-bevel-z-index: 32; --pc-shadow-bevel-content-xs: ''; --pc-shadow-bevel-box-shadow-xs: var(--p-shadow-100); --pc-shadow-bevel-border-radius-xs: var(--p-border-radius-300);"
      >
        <div
          class="Polaris-Box"
          style="--pc-box-background: var(--p-color-bg-surface); --pc-box-min-height: 100%; --pc-box-overflow-x: clip; --pc-box-overflow-y: clip; --pc-box-padding-block-start-xs: var(--p-space-400); --pc-box-padding-block-end-xs: var(--p-space-400); --pc-box-padding-inline-start-xs: var(--p-space-400); --pc-box-padding-inline-end-xs: var(--p-space-400);"
        >
          <div class="Polaris-LegacyStack Polaris-LegacyStack--vertical">
            <div class="Polaris-LegacyStack__Item">
              <h3 class="Polaris-Text--root Polaris-Text--headingMd">Users</h3>
            </div>

            <div
              class="Polaris-LegacyStack__Item"
              v-for="(user, index) of users"
              :key="index"
            >
              <div>
                <label class="Polaris-Choice" :for="`pref_${index}`">
                  <span class="Polaris-Choice__Control">
                    <div class="Polaris-Checkbox">
                      <input
                        :id="`pref_${index}`"
                        v-model="user.emailNotification"
                        type="checkbox"
                        class="Polaris-Checkbox__Input"
                      />
                      <div class="Polaris-Checkbox__Backdrop"></div>
                      <div class="Polaris-Checkbox__Icon">
                        <span class="Polaris-Icon">
                          <svg
                            viewBox="0 0 20 20"
                            class="Polaris-Icon__Svg"
                            focusable="false"
                            aria-hidden="true"
                          >
                            <path
                              d="M8.315 13.859l-3.182-3.417a.506.506 0 0 1 0-.684l.643-.683a.437.437 0 0 1 .642 0l2.22 2.393 4.942-5.327a.437.437 0 0 1 .643 0l.643.684a.504.504 0 0 1 0 .683l-5.91 6.35a.437.437 0 0 1-.642 0"
                            ></path>
                          </svg>
                        </span>
                      </div>
                    </div>
                  </span>
                  <span class="Polaris-Choice__Label">
                    <span class="Polaris-Text--root Polaris-Text--bodyMd">{{
                      user.email
                    }}</span>
                  </span>
                </label>
              </div>
            </div>

            <!-- Commented out section - keeping for reference -->
            <!-- <div class="Polaris-LegacyStack__Item" style="margin-top: var(--p-space-500)">
              <h3 class="Polaris-Text--root Polaris-Text--headingMd">Team Inbox Push notifications</h3>
              <p class="Polaris-Text--root Polaris-Text--bodyMd" style="margin-top: var(--p-space-200)">
                Subscribe for new message notifications in team inbox
              </p>
              <div style="margin-top: var(--p-space-400)">
                <button class="Polaris-Button" @click="enableMessaging">
                  <span class="Polaris-Button__Content">
                    <span class="Polaris-Button__Text">Subscribe</span>
                  </span>
                </button>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      users: [],
      $uiSaveBar: null,
      initialUsers: [] // To track initial state
    };
  },
  computed: {
    hasUnsavedChanges() {
      return (
        Array.isArray(this.users) &&
        this.users.some((user, index) => {
          return (
            user.emailNotification !==
            this.initialUsers[index]?.emailNotification
          );
        })
      );
    }
  },
  watch: {
    hasUnsavedChanges(newVal) {
      if (newVal) {
        this.$uiSaveBar?.show();
      } else {
        this.$uiSaveBar?.hide();
      }
    }
  },
  created() {
    this.$store.dispatch("getUsers").then(response => {
      // Ensure we're getting the users array from the response
      this.users = response.users || [];
      // Store initial state
      this.initialUsers = JSON.parse(JSON.stringify(this.users));
    });
  },
  mounted() {
    this.$uiSaveBar = document.getElementById("my-save-bar");
  },
  methods: {
    onSaveBarSaveClicked() {
      if (!Array.isArray(this.users)) return;

      // Save all changed notifications
      const changedUsers = this.users.filter((user, index) => {
        return (
          user.emailNotification !== this.initialUsers[index]?.emailNotification
        );
      });

      // Update each user's notification setting
      changedUsers.forEach(user => {
        this.$store
          .dispatch("updateNotification", {
            requestParams: {
              userId: user.id,
              emailNotification: user.emailNotification
            }
          })
          .then(() => {
            this.$store.dispatch("showNotification", {
              text: "Notification preferences updated successfully"
            });
            // Update initial state after successful save
            this.initialUsers = JSON.parse(JSON.stringify(this.users));
            this.$uiSaveBar?.hide();
          })
          .catch(() => {
            this.$store.dispatch("showNotification", {
              text: "Failed to update notification preferences"
            });
          });
      });
    },
    onSaveBarDiscardClicked() {
      // Restore original values
      this.users = JSON.parse(JSON.stringify(this.initialUsers));
      this.$uiSaveBar?.hide();
    },
    changeNotificationSetting(user) {
      this.$store
        .dispatch("updateUser", {
          userId: user.id,
          requestParams: {
            emailNotification: user.emailNotification
          }
        })
        .then(() => {
          this.$store.dispatch("showNotification", {
            text: "Notification preference updated successfully"
          });
        })
        .catch(() => {
          this.$store.dispatch("showNotification", {
            text: "Failed to update notification preference"
          });
        });
    }
  }
};
</script>

<style scoped>
.Polaris-Checkbox__Input:checked ~ .Polaris-Checkbox__Icon {
  transform: translate(-50%, -50%) scale(1);
}
.Polaris-Checkbox__Icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0);
  transform-origin: 50% 50%;
  transition: transform 100ms ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: var(--p-color-bg-interactive-selected);
  color: var(--p-color-text-on-bg-interactive);
}
</style>
